import React from 'react';

interface LogoProps {
  isScrolled?: boolean;
}

const Logo: React.FC<LogoProps> = ({ isScrolled = false }) => {
  return (
    <div className="flex items-center py-2">
      <img
        src="/Logo_Redesign_Request_Aug_11_2026.png"
        alt="HTS Electrotechniek Logo"
        className="h-16 w-auto object-contain transition-all duration-300"
        style={isScrolled ? { filter: 'brightness(0) saturate(100%)' } : undefined}
      />
    </div>
  );
};

export default Logo;